import Cookie from 'js-cookie';
import getCookieDomain from '~/functions/getCookieDomain';

export default class CurrencyHandler {
    async changeCurrency(currency) {
        Cookie.set('currencyCode', currency, { domain: getCookieDomain() });
    }
}
